// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/accordance-64.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  color: #000;
  margin: 0px;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  font-size: 14px;
  padding-top: 40px;
}

footer {
  text-align: center;
  padding: 10px;
  margin-bottom: 20px;
  font-size: 13px;
}

ul,
ol {
  padding: 0;
  margin: 0 0 10px 25px;
}

a,
a:link,
a:active,
a:visited,
button.link {
  color: navy;
  text-decoration: none;
}

a:hover,
button.link:hover {
  text-decoration: underline;
}

a.active {
  font-weight: bold;
}

button.link {
  display: inline-block;
  border: none;
  padding: 0px;
  margin: 0;
  text-decoration: none;
  background: inherit;
  font-size: inherit;
  cursor: pointer;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}

h1 {
  font-size: 20px;
}

h2 {
  font-size: 31.5px;
}

h3 {
  font-size: 24.5px;
}

h4 {
  font-size: 17px;
}

h5 {
  font-size: 14px;
}

h6 {
  font-size: 11px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 3px;
  margin-bottom: 3px;
}

.propers h1,
.propers h2,
.propers h3 {
  margin-top: 10px;
  margin-bottom: 10px;
}

hr {
  margin: 20px 0;
  border: 0;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #ffffff;
}

td,
th,
.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

table {
  width: 100%;
}

table,
td,
th {
  border: 1px #000 solid;
  border-spacing: 0px;
  border-collapse: collapse;
}

#calendar-navigation,
#calendar-navigation td {
  border: none;
  vertical-align: bottom;
}

td,
th {
  padding: 10px;
  vertical-align: top;
}

#calendar {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 15px;
  padding-left: 20px;
  padding-right: 20px;
}

.title-bar {
  z-index: 99;
  position: fixed;
  top: 0;
  width: 100%;
  padding: 10px;
  background-color: #000;
}

.title-bar h1 {
  color: #fff;
  font-size: 20px;
  font-weight: 200;
  text-align: center;
}

.small {
  font-size: 85%;
}

.space {
  min-height: 15px;
  height: 15px;
}

#calendar h1,
h2,
h3,
h4,
h5 {
  line-height: 1em !important;
}

#calendar td {
  cursor: pointer;
}

#calendar h3 {
  text-align: center;
  margin-bottom: 7px;
}

#calendar h4,
#calendar h5 {
  text-align: center;
}

#calendar td {
  font-size: 85%;
}

nav {
  display: flex;
  align-items: baseline;
  margin-bottom: 5px;
}

#calendar nav h2 {
  text-align: center;
}

nav>* {
  display: inline-block;
  flex-grow: 1;
  flex-shrink: 1;
}

nav>*:last-child {
  text-align: right;
}

h5 {
  margin-bottom: 7px;
}

sup {
  display: none;
}

.sup {
  vertical-align: super;
  font-size: 0.8em;
  margin-right: 3px;
}

.footnotes,
.hidden {
  display: none;
}

.ical {
  text-align: center;
  padding-top: 10px;
}

.propers {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 25px;
  padding-left: 20px;
  padding-right: 20px;
}

.chapternum {
  font-weight: bold;
  font-size: 1.4em;
}

.versenum {
  display: inline;
}

/* Liturgical Colors */

.highlight-violet {
  background-color: #ee82ee;
}

.violet {
  color: #ee82ee;
}

.highlight-rose {
  background-color: #ff69b4;
}

.rose {
  color: #ff69b4;
}

.highlight-green {
  background-color: #009900;
}

.green {
  color: #009900;
}

.highlight-white {
  background-color: #ffffff;
}

.white {
  color: black;
  -webkit-text-fill-color: white;
  /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
}

.highlight-red {
  background-color: #ff0000;
}

.red {
  color: #ff0000;
}

.highlight-black {
  background-color: #000;
  color: #ffffff;
}

.accordance-icon {
  width: 24px;
  height: 24px;
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
}

/* Calendar View for Mobile */

@media only screen and (min-device-width: 481px) {
  td.today {
    border: 5px #000 solid;
  }

  #calendar td {
    height: 160px;
    max-height: 210px;
    width: 14%;
  }
}

@media only screen and (max-device-width: 480px) {
  .propers {
    font-size: 16px;
  }

  #calendar {
    padding-left: 0px;
    padding-right: 0px;
  }

  #calendar nav {
    padding-left: 7px;
    padding-right: 7px;
  }

  #calendar table {
    border-left: 0px;
    border-right: 0px;
  }

  /* Force table to not be like tables anymore */
  #calendar table,
  #calendar thead,
  #calendar tbody,
  #calendar th,
  #calendar td,
  #calendar tr {
    display: block;
  }

  #calendar {
    border-left: none;
    border-right: none;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  #calendar thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  #calendar td {
    /* Behave  like a "row" */
    border-top: none;
    border-left: none;
    border-right: none;
    position: relative;
    white-space: normal;
    text-align: left;
    font-size: 18px;
  }

  #calendar td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    text-align: left;
    font-weight: bold;
  }

  .highlight-none {
    display: none !important;
  }
}

@media (prefers-color-scheme: dark) {
  body {
    background-color: #000;
    color: #fff;
  }

  a,
  a:link,
  a:active,
  a:visited,
  button.link {
    color: #007db5;
  }

  h2,
  .title-bar a,
  .title-bar a:hover {
    color: #fff;
  }

  #calendar {
    color: #000;
  }
}

@media only screen and (prefers-color-scheme: dark) and (min-device-width: 481px) {
  #calendar table {
    outline: 1px #fff solid;
  }

  #calendar th {
    color: #fff;
    border-bottom-color: #fff;
  }

  #calendar td.today {
    border: 5px #fff solid;
  }
}
`, "",{"version":3,"sources":["webpack://./app/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;EACX;uCACqC;EACrC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,qBAAqB;AACvB;;AAEA;;;;;EAKE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;EAME,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;;AAEtB;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,8CAA8C;EAC9C,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yDAAmD;EACnD,wBAAwB;AAC1B;;AAEA,6BAA6B;;AAE7B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,8CAA8C;EAC9C;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,mEAAmE;EACnE;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,kCAAkC;IAClC,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;;;;IAKE,cAAc;EAChB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["body {\n  color: #000;\n  margin: 0px;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  font-size: 14px;\n  padding-top: 40px;\n}\n\nfooter {\n  text-align: center;\n  padding: 10px;\n  margin-bottom: 20px;\n  font-size: 13px;\n}\n\nul,\nol {\n  padding: 0;\n  margin: 0 0 10px 25px;\n}\n\na,\na:link,\na:active,\na:visited,\nbutton.link {\n  color: navy;\n  text-decoration: none;\n}\n\na:hover,\nbutton.link:hover {\n  text-decoration: underline;\n}\n\na.active {\n  font-weight: bold;\n}\n\nbutton.link {\n  display: inline-block;\n  border: none;\n  padding: 0px;\n  margin: 0;\n  text-decoration: none;\n  background: inherit;\n  font-size: inherit;\n  cursor: pointer;\n  text-align: center;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  cursor: pointer;\n}\n\nh1 {\n  font-size: 20px;\n}\n\nh2 {\n  font-size: 31.5px;\n}\n\nh3 {\n  font-size: 24.5px;\n}\n\nh4 {\n  font-size: 17px;\n}\n\nh5 {\n  font-size: 14px;\n}\n\nh6 {\n  font-size: 11px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 3px;\n  margin-bottom: 3px;\n}\n\n.propers h1,\n.propers h2,\n.propers h3 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\nhr {\n  margin: 20px 0;\n  border: 0;\n  border-top: 1px solid #eeeeee;\n  border-bottom: 1px solid #ffffff;\n}\n\ntd,\nth,\n.text-center {\n  text-align: center;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\ntable {\n  width: 100%;\n}\n\ntable,\ntd,\nth {\n  border: 1px #000 solid;\n  border-spacing: 0px;\n  border-collapse: collapse;\n}\n\n#calendar-navigation,\n#calendar-navigation td {\n  border: none;\n  vertical-align: bottom;\n}\n\ntd,\nth {\n  padding: 10px;\n  vertical-align: top;\n}\n\n#calendar {\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 15px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.title-bar {\n  z-index: 99;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  padding: 10px;\n  background-color: #000;\n}\n\n.title-bar h1 {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 200;\n  text-align: center;\n}\n\n.small {\n  font-size: 85%;\n}\n\n.space {\n  min-height: 15px;\n  height: 15px;\n}\n\n#calendar h1,\nh2,\nh3,\nh4,\nh5 {\n  line-height: 1em !important;\n}\n\n#calendar td {\n  cursor: pointer;\n}\n\n#calendar h3 {\n  text-align: center;\n  margin-bottom: 7px;\n}\n\n#calendar h4,\n#calendar h5 {\n  text-align: center;\n}\n\n#calendar td {\n  font-size: 85%;\n}\n\nnav {\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 5px;\n}\n\n#calendar nav h2 {\n  text-align: center;\n}\n\nnav>* {\n  display: inline-block;\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n\nnav>*:last-child {\n  text-align: right;\n}\n\nh5 {\n  margin-bottom: 7px;\n}\n\nsup {\n  display: none;\n}\n\n.sup {\n  vertical-align: super;\n  font-size: 0.8em;\n  margin-right: 3px;\n}\n\n.footnotes,\n.hidden {\n  display: none;\n}\n\n.ical {\n  text-align: center;\n  padding-top: 10px;\n}\n\n.propers {\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 25px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.chapternum {\n  font-weight: bold;\n  font-size: 1.4em;\n}\n\n.versenum {\n  display: inline;\n}\n\n/* Liturgical Colors */\n\n.highlight-violet {\n  background-color: #ee82ee;\n}\n\n.violet {\n  color: #ee82ee;\n}\n\n.highlight-rose {\n  background-color: #ff69b4;\n}\n\n.rose {\n  color: #ff69b4;\n}\n\n.highlight-green {\n  background-color: #009900;\n}\n\n.green {\n  color: #009900;\n}\n\n.highlight-white {\n  background-color: #ffffff;\n}\n\n.white {\n  color: black;\n  -webkit-text-fill-color: white;\n  /* Will override color (regardless of order) */\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: black;\n}\n\n.highlight-red {\n  background-color: #ff0000;\n}\n\n.red {\n  color: #ff0000;\n}\n\n.highlight-black {\n  background-color: #000;\n  color: #ffffff;\n}\n\n.accordance-icon {\n  width: 24px;\n  height: 24px;\n  display: inline-block;\n  background-image: url('./images/accordance-64.png');\n  background-size: contain;\n}\n\n/* Calendar View for Mobile */\n\n@media only screen and (min-device-width: 481px) {\n  td.today {\n    border: 5px #000 solid;\n  }\n\n  #calendar td {\n    height: 160px;\n    max-height: 210px;\n    width: 14%;\n  }\n}\n\n@media only screen and (max-device-width: 480px) {\n  .propers {\n    font-size: 16px;\n  }\n\n  #calendar {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  #calendar nav {\n    padding-left: 7px;\n    padding-right: 7px;\n  }\n\n  #calendar table {\n    border-left: 0px;\n    border-right: 0px;\n  }\n\n  /* Force table to not be like tables anymore */\n  #calendar table,\n  #calendar thead,\n  #calendar tbody,\n  #calendar th,\n  #calendar td,\n  #calendar tr {\n    display: block;\n  }\n\n  #calendar {\n    border-left: none;\n    border-right: none;\n  }\n\n  /* Hide table headers (but not display: none;, for accessibility) */\n  #calendar thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  #calendar td {\n    /* Behave  like a \"row\" */\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    position: relative;\n    white-space: normal;\n    text-align: left;\n    font-size: 18px;\n  }\n\n  #calendar td:before {\n    /* Now like a table header */\n    position: absolute;\n    /* Top/left values mimic padding */\n    top: 6px;\n    left: 6px;\n    width: 45%;\n    padding-right: 10px;\n    white-space: nowrap;\n    text-align: left;\n    font-weight: bold;\n  }\n\n  .highlight-none {\n    display: none !important;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  body {\n    background-color: #000;\n    color: #fff;\n  }\n\n  a,\n  a:link,\n  a:active,\n  a:visited,\n  button.link {\n    color: #007db5;\n  }\n\n  h2,\n  .title-bar a,\n  .title-bar a:hover {\n    color: #fff;\n  }\n\n  #calendar {\n    color: #000;\n  }\n}\n\n@media only screen and (prefers-color-scheme: dark) and (min-device-width: 481px) {\n  #calendar table {\n    outline: 1px #fff solid;\n  }\n\n  #calendar th {\n    color: #fff;\n    border-bottom-color: #fff;\n  }\n\n  #calendar td.today {\n    border: 5px #fff solid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
